var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstructionManualManualInstructionsSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "208px",
    height: "256px",
    viewBox: "0 0 208 256",
    enableBackground: "new 0 0 208 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,35c0,0,0,184.486,0,186c0,17.87,14.416,32.192,32.084,32.899V254H205.82v-9.288c-13.226,0-23.928-10.702-23.928-23.928 s10.702-23.928,23.928-23.928v-0.202V2H35.8C17.526,2,2,16.726,2,35z M172.603,220.683c0,9.389,4.038,17.87,10.298,23.928H35.397 c-13.226,0.101-24.029-10.702-24.029-23.928c0-12.519,9.793-22.817,22.111-23.726l149.726-0.303 C176.743,202.712,172.603,211.192,172.603,220.683z M107.555,54.505c11.872-11.872,31.068-11.993,43.021-0.04s11.912,31.23,0,43.142 c-7.646,7.646-18.311,10.343-28.09,8.21l-10.101,10.101l-16.54-3.34l1.69,14.729l-12.677-3.26l1.69,14.569l-13.079-3.34l1.61,14.81 l-22.899,1.65l-0.563-21.732l47.649-47.649C97.212,72.655,99.989,62.071,107.555,54.505z M135.766,69.355 c-2.616-2.616-2.656-6.922,0-9.578c2.656-2.656,6.922-2.656,9.578,0c2.656,2.656,2.656,6.922,0,9.578 C142.648,72.051,138.382,71.971,135.766,69.355z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionManualManualInstructionsSvgrepoCom);
export default __webpack_public_path__ + "static/media/instruction-manual-manual-instructions-svgrepo-com.04239ac92a9de668555cea415363f2d9.svg";
export { ForwardRef as ReactComponent };